<template>
  <f7-block>
    <f7-block-title>{{ $t('adminDashboard.kyc') }}</f7-block-title>
    <div class="metric-grid">
      <div class="metric-card">
        <f7-icon f7="clock" size="18" class="metric-icon color-orange" />
        <span class="metric-lbl">{{ $t('adminDashboard.pendingKyc') }}</span>
        <span class="metric-val">{{ fmt(data.pendingKycVerifications) }}</span>
      </div>
      <div class="metric-card">
        <f7-icon f7="checkmark_circle_fill" size="18" class="metric-icon color-green" />
        <span class="metric-lbl">{{ $t('adminDashboard.verifiedKyc') }}</span>
        <span class="metric-val">{{ fmt(data.verifiedKycCount) }}</span>
      </div>
      <div class="metric-card">
        <f7-icon f7="xmark_circle_fill" size="18" class="metric-icon color-red" />
        <span class="metric-lbl">{{ $t('adminDashboard.rejectedKyc') }}</span>
        <span class="metric-val">{{ fmt(data.rejectedKycCount) }}</span>
      </div>
      <div class="metric-card">
        <f7-icon f7="percent" size="18" class="metric-icon color-blue" />
        <span class="metric-lbl">{{ $t('adminDashboard.kycApprovalRate') }}</span>
        <span class="metric-val">{{ pct(data.kycApprovalRate) }}</span>
      </div>
    </div>
  </f7-block>
</template>
<script setup>
const props = defineProps({ data: { type: Object, required: true } });
function fmt(n) { return n != null ? Math.round(n).toLocaleString('fr-FR') : '-'; }
function pct(v) { return v != null ? v.toFixed(1) + '%' : '-'; }
</script>
<style scoped>
.metric-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); gap: 10px; }
.metric-card { display:flex; flex-direction:column; align-items:center; gap:4px; padding:14px 8px; border-radius:12px; background:var(--f7-list-bg-color,#f5f5f5); }
.metric-icon { margin-bottom:2px; }
.metric-lbl { font-size:11px; color:var(--f7-on-surface-variant,#8e8e93); text-align:center; line-height:1.3; }
.metric-val { font-size:20px; font-weight:700; color:var(--f7-text-color,#333); }
</style>